<template>
  <i class="TkUpArrow" />
</template>

<script>
export default {
  name: 'TkUpArrow',
}
</script>

<style lang="scss">
.TkUpArrow {
  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
  }

  &::after {
    border-right: 2px solid;
    border-top: 2px solid;
    height: 5px;
    width: 5px;
    position: absolute;
    top: 3px;
    bottom: 0;
    left: 3px;
    margin: auto;
    content: "";
    vertical-align: middle;
    transform: rotate(315deg);
  }
}
</style>
